import React from "react";
import { Box, Typography, CircularProgress, Chip } from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

const TopBar = ({ customersLoading, customersReady, scannedCount }) => (
  <Box
    sx={{
      bgcolor: "#0563B0",
      color: "#fff",
      px: 2,
      py: 2,
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
      direction: "ltr",
    }}
  >
    <QrCodeScannerIcon sx={{ fontSize: 28 }} />
    <Typography sx={{ fontWeight: 700, fontSize: "1.1rem" }}>
      מיפוי מכשירים – סריקת QR
    </Typography>
    {customersLoading && !customersReady && (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, ml: "auto" }}>
        <CircularProgress size={16} sx={{ color: "#fff" }} />
        <Typography sx={{ fontSize: "0.75rem", opacity: 0.9 }}>טוען לקוחות...</Typography>
      </Box>
    )}
    {scannedCount > 0 && (
      <Chip
        label={scannedCount}
        size="small"
        sx={{
          ml: customersLoading && !customersReady ? 1 : "auto",
          bgcolor: "#fff",
          color: "#0563B0",
          fontWeight: 700,
        }}
      />
    )}
  </Box>
);

export default TopBar;
